import { modals } from "../modals/init-modals";

const crmRequest =
  "https://n8n.edusigmatecharskay.ru/webhook/concepta/7/amo/update-data/oJUawcDYbg0yoXEH";
const webhook =
  "https://n8n.edusigmatecharskay.ru/webhook/n8n/landing_cok/NvayPwgTF7YZXGaN/18108f";

/* Получение cookie */
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const baseSuccessCallback = (event) => {
  event.preventDefault();
  const formData = Object.fromEntries(new FormData(event.target));
  formData["Landing"] =
    document.location.href.split("?")[0] || document.location.href;

  /* Ройстат */
  let roistatCookie = getCookie("roistat_visit");

  if (!!roistatCookie) {
    formData["RoistatCookie"] = roistatCookie;
  }

  /* yclid */
  let ym_uid = getCookie("_ym_uid");
  if (ym_uid) {
    formData["ClientId"] = ym_uid;
  }

  /* UTM */
  const url = document.location.href,
    paramsStartIndex = url.indexOf("?");

  try {
    if (paramsStartIndex > -1) {
      url
        .slice(paramsStartIndex + 1, url.length)
        .split("&")
        .map(function (utmString) {
          return utmString.split("=");
        })
        .forEach(function (utmMark) {
          let key = utmMark[0];
          key = key[0].toUpperCase() + key.slice(1, key.length);
          let value = utmMark[1];
          value =
            value.indexOf("#") > -1
              ? value.slice(0, value.indexOf("#"))
              : value;
          formData[key] = value;
        });
    }
  } catch (e) {
    console.log(e);
  }

  // Функция для отправки метрик и показа успеха
  const showSuccess = () => {
    ym(105136647, "reachGoal", "FormSubmit");
    VK.Goal("lead");
    VK.Retargeting.Event("lead");
    _tmr.push({ type: "reachGoal", id: 3721015, goal: "lead" });
    modals.open("submit-modal");
  };

  // Отправка в CRM
  fetch(crmRequest, {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=utf-8" },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response.ok) {
        return response;
      }
      throw new Error(`${response.status} ${response.statusText}`);
    })
    .then(() => {
      // Показываем успех сразу после отправки в CRM
      showSuccess();

      // Затем пытаемся отправить на webhook
      return fetch(webhook, {
        method: "POST",
        headers: { "Content-Type": "application/json;charset=utf-8" },
        body: JSON.stringify(formData),
      });
    })
    .then((response) => {
      if (response.ok) {
        return response.json().then((data) => {
          console.log("Форма отправлена на вебхук");

          // Сохраняем ссылку на бот в переменной, чтобы использовать при закрытии модалки
          const LINK_BOT = `https://t.me/free_classes_bot?start=landing_${data.hash}`;

          // Изменения ссылок на модальном окне успеха
          const LINKS_MODAL_BOT = document.querySelectorAll('[data-link-form-bot]');

          if (LINKS_MODAL_BOT) {
            LINKS_MODAL_BOT.forEach(link => {
              link.href = LINK_BOT;
            })

            console.log('Заменены ссылки в модальном окне');
          }

          // Подписываемся на закрытие модалки
          document.addEventListener(
            "modalClosed",
            function (event) {
              const modalName = event.detail.modalName;

              if (modalName === "submit-modal") {
                // Используем сохраненную ссылку
                window.location.assign(LINK_BOT);
              }
            },
            { once: true },
          );
        });
      } else {
        console.warn(`Ошибка отправки на вебхук: ${response.status}`);
      }
    })
    .catch(function (error) {
      if (error.message && error.message.includes("Webhook error")) {
        // Это ошибка webhook (уже после успеха CRM)
        console.warn(
          "Успешно отправлено в CRM, ошибка отправки на вебхук",
          error.message,
        );
      } else {
        // Ошибка в отправке CRM - показываем модалку ошибки
        console.error("Ошибка отправки в CRM:", error);
        modals.open("fail-modal");
      }
    });
};

const baseErrorCallback = (event) => {
  event.preventDefault();
  // Данный коллбек используется при необходимости выполнить какое-либо действие помимо показа ошибок при попытке отправить неккорректные данные, он не связан с запросами на сервер
};

export const callbacks = {
  base: {
    // Сбросс формы
    reset: true,
    // Таймаут сброса формы
    resetTimeout: 500,
    successCallback: baseSuccessCallback,
    errorCallback: baseErrorCallback,
  },
};
